import { COHORT_FIELD_DEFINITIONS, type CohortCondition, type CohortFieldId } from "@unbox/api";

export const FIELD_OPTIONS = (Object.keys(COHORT_FIELD_DEFINITIONS) as CohortFieldId[]).map((id) => ({
  id,
  label: COHORT_FIELD_DEFINITIONS[id].label,
  supportingText: COHORT_FIELD_DEFINITIONS[id].tooltip,
}));

export const NUMERIC_OPERATOR_OPTIONS: { id: CohortCondition["operator"]; label: string }[] = [
  { id: "eq", label: "is" },
  { id: "gt", label: "greater than" },
  { id: "gte", label: "at least" },
  { id: "lt", label: "less than" },
  { id: "lte", label: "at most" },
  { id: "between", label: "between" },
];

export function defaultConditionForField(field: CohortFieldId): CohortCondition {
  // Every cohort field is numeric, so this shape satisfies the discriminated union
  // for any `field` — the cast only stands in for the literal `field` narrowing.
  return { field, operator: "gt", value: 0 } as CohortCondition;
}

export function makeDefaultCondition(): CohortCondition {
  return defaultConditionForField("gmvAmount");
}

export function isConditionComplete(condition: CohortCondition): boolean {
  if (condition.operator === "between") {
    return Array.isArray(condition.value) && condition.value.length === 2 && condition.value.every(Number.isFinite);
  }
  return typeof condition.value === "number" && Number.isFinite(condition.value);
}
